import { LocaleValuesFragment } from 'src/generated/operations.ts';

export const isLocaleValuesFragment = (
    value: unknown,
): value is LocaleValuesFragment => !!value && typeof value === 'object' && 'localized' in value && 'raw' in value;
